module.exports = {
    "Clear search": `T\xfchjenda otsing`
};


//# sourceMappingURL=et-EE.main.js.map
